// NOTE: Using named exports for better tree-shaking
// Individual icon components can be imported directly for optimal bundle size

/* Gleicher Import, aber optimiert
import { Icon, EIcons } from '@/components/icons';

→ Lädt nur: Icon + EIcons + verwendete Icons = ~5kb
*/

/* Oder direkter Import für maximale Optimierung:
import { IconChevron } from '@/components/icons';
→ Lädt nur: IconChevron = ~1kb
*/

export { IconArrowLeftButton } from './arrow-left-button';
export { IconArrowRightButton } from './arrow-right-button';
export { IconChevron } from './chevron';
export { IconChevronLeft } from './chevron-left';
export { IconChevronRight } from './chevron-right';
export { IconClose } from './close';
export { IconCloseButton } from './close-button';
export { IconLock } from './lock';
export { IconPlus } from './plus';

// Re-export the Icon wrapper component and enum
export { EIcons } from './EIcons';
export { Icon } from './Icon';
